<template>
  <div class="interview-format-templates settings-templates">
    <EditInterviewFormatTemplateAction
      :interviewFormatTemplate="currentInterviewFormatTemplate"
      :isOpen="isOpen"
      @close="closeDialog"
    />
    <div class="container col-lg-8 col-sm-12 mb-12">
      <BaseListToolbar title="Interviews" @search="updateSearchValue" />
      <div v-if="isFetchingOrganisationInterviewFormatTemplates">
        <v-skeleton-loader v-for="i in 5" :key="i" s type="list-item-avatar" />
      </div>
      <div v-else>
        <v-list-item
          v-for="interviewFormatTemplate in interviewFormatTemplates"
          :key="interviewFormatTemplate.id"
          @click="handleSelect(interviewFormatTemplate)"
        >
          <InterviewFormatTemplateItem
            :interviewFormatTemplate="interviewFormatTemplate"
          />
        </v-list-item>
      </div>
      <v-pagination
        :total-visible="page.pageSize"
        v-if="showPagination"
        v-model="page.currentPage"
        @input="loadInterviewTemplates"
        :length="page.lastPage"
      />
      <BaseFooter>
        <NewInterviewFormatTemplateAction />
      </BaseFooter>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_INTERVIEW_FORMAT_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-interview-format-templates";
import { FETCH_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES } from "@/store/modules/organisations/organisation-interview-format-templates/actions";
import { copyState } from "@/utils/helpers";
import InterviewFormatTemplateItem from "@/views/settings/components/interview-format-templates/components/InterviewFormatTemplateItem";
import BaseFooter from "@/components/common/BaseFooter";
import NewInterviewFormatTemplateAction from "@/views/settings/components/interview-format-templates/components/actions/NewInterviewFormatTemplateAction";
import EditInterviewFormatTemplateAction from "@/views/settings/components/interview-format-templates/components/dialogs/EditInterviewFormatTemplateDialog";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import { map, size } from "lodash";
import { getListedArray } from "@/utils/helpers";
import { paginationMixin } from "@/mixins/pagination.mixin";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_INTERVIEW_FORMAT_TEMPLATES_NAMESPACE
);

export default {
  name: "InterviewFormatTemplates",
  mixins: [paginationMixin],
  components: {
    InterviewFormatTemplateItem,
    BaseFooter,
    NewInterviewFormatTemplateAction,
    EditInterviewFormatTemplateAction,
    BaseListToolbar
  },
  created() {
    this.loadInterviewTemplates();
  },
  data() {
    return {
      isOpen: false,
      currentInterviewFormatTemplate: {},
      searchText: ""
    };
  },
  computed: {
    ...mapState(
      copyState([
        "organisationInterviewFormatTemplates",
        "isFetchingOrganisationInterviewFormatTemplates"
      ])
    ),
    interviewFormatTemplates() {
      return map(this.organisationInterviewFormatTemplates, template => {
        const formattedTags = getListedArray(template.tags);
        return { ...template, formattedTags };
      });
    },
    requestParams() {
      return {
        filter: {
          ...(size(this.searchText) && { interviewName: this.searchText })
        },
        ...this.requestPageParams
      };
    }
  },
  methods: {
    ...mapActions({
      fetchInterviewFormatTemplates: FETCH_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES
    }),
    handleSelect(template) {
      this.currentInterviewFormatTemplate = template;
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    },
    async loadInterviewTemplates() {
      const data = await this.fetchInterviewFormatTemplates(this.requestParams);
      if (data) {
        this.updatePageDetails(data.meta);
      }
    },
    updateSearchValue(text) {
      this.searchText = text;
      this.resetPagination();
      this.loadInterviewTemplates();
    }
  }
};
</script>

<style lang="scss"></style>
